import axios, { AxiosPromise } from 'axios'

import { IParamsFile } from 'aem-libs-react-ts/src/models'

import {
  IRegInvestAmountRequest,
  IRegInvestAmountResponse,
  IRegInvestSavingsRequest,
  IRegInvestSavingsResponse,
} from './types'

export const regularInvestmentService = (() => {
  const apiBase = 'v2/calc/regInvest/'

  const calcAmount = (
    configFileParams: IParamsFile,
    data: IRegInvestAmountRequest,
  ): AxiosPromise<IRegInvestAmountResponse> => {
    const headers = { 'Web-Api-Key': configFileParams.webApi.key }
    return axios.post(configFileParams.webApi.url + apiBase + 'amount', data, {
      headers,
    })
  }

  const calcSavings = (
    configFileParams: IParamsFile,
    data: IRegInvestSavingsRequest,
  ): AxiosPromise<IRegInvestSavingsResponse> => {
    const headers = { 'Web-Api-Key': configFileParams.webApi.key }
    return axios.post(configFileParams.webApi.url + apiBase + 'savings', data, {
      headers,
    })
  }

  return {
    calcAmount,
    calcSavings,
  }
})()
